/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionsBoardReferralAssignmentsInner
 */
export interface AdmissionsBoardReferralAssignmentsInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: AdmissionsBoardReferralAssignmentsInnerRoleEnum;
}


/**
 * @export
 */
export const AdmissionsBoardReferralAssignmentsInnerRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type AdmissionsBoardReferralAssignmentsInnerRoleEnum = typeof AdmissionsBoardReferralAssignmentsInnerRoleEnum[keyof typeof AdmissionsBoardReferralAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the AdmissionsBoardReferralAssignmentsInner interface.
 */
export function instanceOfAdmissionsBoardReferralAssignmentsInner(value: object): value is AdmissionsBoardReferralAssignmentsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function AdmissionsBoardReferralAssignmentsInnerFromJSON(json: any): AdmissionsBoardReferralAssignmentsInner {
    return AdmissionsBoardReferralAssignmentsInnerFromJSONTyped(json, false);
}

export function AdmissionsBoardReferralAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardReferralAssignmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function AdmissionsBoardReferralAssignmentsInnerToJSON(json: any): AdmissionsBoardReferralAssignmentsInner {
    return AdmissionsBoardReferralAssignmentsInnerToJSONTyped(json, false);
}

export function AdmissionsBoardReferralAssignmentsInnerToJSONTyped(value?: AdmissionsBoardReferralAssignmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'role': value['role'],
    };
}

